import { useProduction } from "../state/production";

export default function useRendered(clip) {
	const modified = useProduction()?.render?.modified;

	return clip.toOutside(clip.end) <= modified;
}
